import React, { useState, useEffect } from "react";
import TimeOutModal from "./TimeOutModal"
import { addEventListeners, removeEventListeners } from './TimeOutEvents'

const TimeOut = () => {

  const [isModalOpen, setIsModalOpen] = useState(false)

  async function logOut() {
    try {
      await fetch(`${process.env.REACT_APP_API}/user/UserLogout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      }).then(() => {
        redirectToLoginPage();
      }).catch(() => {
        // Redirect to login page even if logout API fails
        redirectToLoginPage();
      });
    } catch (error) {
      // Redirect to login page even if logout API fails
      redirectToLoginPage();
    }
  }

  // Function to redirect to login page
  const redirectToLoginPage = () => {
    sessionStorage.removeItem("sessionToken", null);
    sessionStorage.removeItem('currentUserDetails', null);
    window.location.replace("/");
    localStorage.setItem("token", null);
  };
  
  const idleTimeOut1ShowModal = () => setTimeout(() => { 
    setIsModalOpen(true)
  }, (60000 * Number(process.env.REACT_APP_ALERT_TIME_OUT)))// 60000 Milli Seconds = 60 Seconds = 1 Minute, example, (1 minute * 5) = Show Alert in 5 Minutes

  const idleTimeOut2Logout = () => setTimeout(() => {
    logOut()
  }, 10000)// 10000 Milli Seconds = 10 Seconds, After shown the alert then auto Logout in 10 Seconds.

  useEffect(() => {
    let timeout
  
    const listener = () => {
        clearTimeout(timeout)
        timeout = idleTimeOut1ShowModal();
    } 

    // Initialization
    timeout = isModalOpen  ? idleTimeOut2Logout() : idleTimeOut1ShowModal()
    addEventListeners(listener);

    // Cleanup
    return () => {
      clearTimeout(timeout);
      removeEventListeners(listener);
    }
  }, [isModalOpen, idleTimeOut1ShowModal, idleTimeOut2Logout])

  return (
    <div>
      {isModalOpen && (
        <TimeOutModal 
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          logOut={logOut}
        />
        )
      }
    </div>
  ) 
}

export default TimeOut;
